import React, { useEffect, useState } from "react";
import { SdsForm } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose } from "../../services/notifyService";

import { post } from "../../services/smartApiService";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import { EMAIL_SETTINGS_URLS } from "../../api/AdminUrls";

interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}

const schema = Yup.object({
  mail_name: Yup.string()
    .required("Mail Name is required")
    .min(3, "Mail Name must be at least 3 characters long")
    .max(50, "Mail Name must not exceed 50 characters"),
  mail_subject: Yup.string()
    .required("Mail Subject is required")
    .min(3, "Mail Subject must be at least 3 characters long")
    .max(100, "Mail Subject must not exceed 100 characters"),
    mail_msg: Yup.string()
    .required("Message is required")
    .min(10, "Message must be at least 10 characters long")
    .max(500, "Message must not exceed 500 characters"),
});

const EmailSettingsForm: React.FC<HeaderProps> = ({ dataIn, loadTableData }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();
  const [types, setTypes] = useState([]);

  const onSubmit = (formData: any) => {
    let url = EMAIL_SETTINGS_URLS.INSERT;
    if (dataIn.ID !== undefined) {
      formData["id"] = dataIn.ID;
      url = EMAIL_SETTINGS_URLS.UPDATE;
    }

    const subscription = post(url, formData).subscribe((response) => {
      showAlertAutoClose("Data Saved Successfully", "success");
      closeModal();
      loadTableData();
    });
    return () => subscription.unsubscribe();
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "mail_name",
      element: { label: "Mail Name", isRequired: true },
    },
    {
      type: "TEXT_BOX",
      width: 12,
      name: "mail_subject",
      element: { label: "Mail Subject", isRequired: true },
    },
    {
      type: "TEXTAREA",
      width: 12,
      name: "mail_msg",
      element: { label: "Message", isRequired: true, rows: 30, richEditor: true },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",
      class_name: "has-text-right",
      element: {
        label: "Submit",
        onClick: handleSubmit(onSubmit),
        classList: ["smart-action-button"],
      },
    },
  ];

  return (
    <div className="sd-efl-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default EmailSettingsForm;
